<template>
  <WLLink
    ref="elRef"
    :to="to"
    :href="href"
    :fallback-component="fallbackComponent"
    class="wl-list-item focus-visible:outline-accent-emphasis relative flex w-full items-center rounded-2xl transition duration-150 outline-none focus-visible:outline focus-visible:outline-offset-2"
    :class="{
      'is-boxed bg-muted px-3 py-2': isBoxed,
      'is-disabled pointer-events-none cursor-default opacity-30': isDisabled,
      'has-hover': hasHover,
      'is-link cursor-pointer': to || href,
    }"
  >
    <template v-if="$slots.prefix">
      <slot name="prefix" />
    </template>
    <div v-if="content || label" class="truncate">
      <p
        v-if="label"
        ref="labelRef"
        class="wl-list-item__label text-muted truncate text-sm font-normal"
      >
        {{ label }}
      </p>
      <p
        v-if="content"
        ref="contentRef"
        class="wl-list-item__content text-emphasis truncate text-sm font-medium"
      >
        {{ content }}
      </p>
    </div>
    <div v-if="$slots.suffix" ref="suffixRef" class="ml-auto">
      <slot name="suffix" />
    </div>
  </WLLink>
</template>

<script setup lang="ts">
import { toRefs } from "vue";
import type { ListItemProps } from "./types";
import { WLLink } from "../link";

const props = withDefaults(defineProps<ListItemProps>(), {
  isBoxed: false,
  isDisabled: false,
  fallbackComponent: "li",
});

const { content, label, isBoxed, isDisabled, hasHover, to, href } =
  toRefs(props);
</script>

<style>
@reference "@theme";

.wl-list-item {
  .check-icon path {
    stroke-dashoffset: 16;
    stroke-dasharray: 16;
  }

  &.has-hover {
    @apply hover:bg-emphasis active:bg-emphasis;
  }

  &.is-link {
    .wl-list-item__content {
      text-decoration: underline;
    }
  }
}
</style>
